import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import ConversationStartersList from "../../../components/ConversationStartersList";

type ConversationPanelProps = {
  onClose: () => void;
};

export default function ConversationPanel({ onClose }: ConversationPanelProps) {
  return (
    <View style={styles.panel}>
      <View style={styles.header}>
        <Text style={styles.title}>Conversation Starters</Text>
        <TouchableOpacity onPress={onClose} style={styles.closeButton}>
          <Ionicons name="close" size={16} color="#fff" />
        </TouchableOpacity>
      </View>

      <ConversationStartersList style={styles.list} />
    </View>
  );
}

const styles = StyleSheet.create({
  panel: {
    width: 922,
    height: 598,
    backgroundColor: "#393947",
    borderRadius: 16,
    paddingVertical: 20,
    paddingHorizontal: 24,
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 6,
  },
  title: {
    fontSize: 20,
    fontWeight: "700",
    color: "#fff",
    fontFamily: "LexendBold",
  },
  closeButton: {
    width: 43,
    height: 43,
    borderRadius: 100,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  list: {
    marginTop: 4,
  },
});
